import { useCallback } from 'react';
import { MetaGameType } from '../state/metaGames.types';
import { useNavigation } from '@bonanza-social/navigation';

const useLaunchMetaGame = (gameType: MetaGameType) => {
  const navigation = useNavigation();

  const launchMetaGame = useCallback(
    () => navigation.navigate('MetaGame', { gameType }),
    [navigation, gameType],
  );

  return launchMetaGame;
};

export default useLaunchMetaGame;
